
<div class="position-relative vip-wave-video">
  <div class="text-center">
    <div class="position-absolute w-100 h-100" style="background-color: #0a0a0a70;"></div>
    <video id="vipVideo" class="w-100 h-100" style="object-fit:cover;" [src]="video_url" autoplay [muted]="'muted'" loop>
    </video>
    <div class="position-absolute top-35 start-50 translate-middle w-100">
      <div class="home-heading text-white">The more you rate, the smarter it gets</div>
    </div>
  </div>
</div>